const BillStatusType = Object.freeze({
  Inactive: { value: 0, name: 'Inactive' },
  Active: { value: 1, name: 'Active' },
  Canceled: { value: 2, name: 'Canceled' }
});

const PaymentStatusType = Object.freeze({
  FreeTrial: { value: 0, name: 'Free Trial' },
  Paid: { value: 1, name: 'Paid' },
  UnPaid: { value: 2, name: 'Un Paid' },
  FreeOfCharge: { value: 3, name: 'Free Of Charge' }
});

export function parseBillStatusTypeToString(billStatus: number) {
  switch (billStatus) {
    case BillStatusType.Inactive.value:
      return BillStatusType.Inactive.name;
    case BillStatusType.Active.value:
      return BillStatusType.Active.name;
    case BillStatusType.Canceled.value:
      return BillStatusType.Canceled.name;
    default:
      return '';
  }
}

export function parsePaymentStatusToString(paymentStatus: number) {
  switch (paymentStatus) {
    case PaymentStatusType.FreeTrial.value:
      return PaymentStatusType.FreeTrial.name;
    case PaymentStatusType.Paid.value:
      return PaymentStatusType.Paid.name;
    case PaymentStatusType.UnPaid.value:
      return PaymentStatusType.UnPaid.name;
    case PaymentStatusType.FreeOfCharge.value:
      return PaymentStatusType.FreeOfCharge.name;
    default:
      return '';
  }
}

export function getConnectedChannelTotalCount(connectedChannel: any) {
  if (connectedChannel == null) return 0;

  let count = 0;
  if (connectedChannel.whatsAppConfigs != null)
    count += connectedChannel.whatsAppConfigs.length;
  if (connectedChannel.wsChatAPIConfigs != null)
    count += connectedChannel.wsChatAPIConfigs.length;
  if (connectedChannel.facebookConfigs != null)
    count += connectedChannel.facebookConfigs.length;
  if (connectedChannel.leadAdsFacebookConfigs != null)
    count += connectedChannel.leadAdsFacebookConfigs.length;
  if (connectedChannel.instagramConfigs != null)
    count += connectedChannel.instagramConfigs.length;
  if (connectedChannel.weChatConfig != null) count += 1;
  if (connectedChannel.lineConfigs != null)
    count += connectedChannel.lineConfigs.length;
  if (connectedChannel.viberConfigs != null)
    count += connectedChannel.viberConfigs.length;
  if (connectedChannel.telegramConfigs != null)
    count += connectedChannel.telegramConfigs.length;
  if (connectedChannel.emailConfig != null) count += 1;
  if (connectedChannel.liveChatConfig != null) count += 1;
  if (connectedChannel.smsConfigs != null)
    count += connectedChannel.smsConfigs.length;
  if (connectedChannel.whatsApp360DialogConfigs != null)
    count += connectedChannel.whatsApp360DialogConfigs.length;
  if (connectedChannel.whatsappCloudApiConfigs != null)
    count += connectedChannel.whatsappCloudApiConfigs.length;
  if (connectedChannel.twilioSmsConfigs != null)
    count += connectedChannel.twilioSmsConfigs.length;
  if (connectedChannel.tikTokConfigs != null)
    count += connectedChannel.tikTokConfigs.length;

  return count;
}

export function getConnectedChannelFilterString(connectedChannel: any) {
  if (connectedChannel == null) return '';

  let filterString = '';

  if (connectedChannel.emailConfigCount > 0) filterString += 'email';
  if (connectedChannel.facebookConfigCount > 0) filterString += 'facebookfb';
  if (connectedChannel.instagramConfigCount > 0) filterString += 'instagramig';
  if (connectedChannel.lineConfigCount > 0) filterString += 'line';
  if (connectedChannel.shopifyConfigCount > 0) filterString += 'shopify';
  if (connectedChannel.smsConfigCount > 0) filterString += 'sms';
  if (connectedChannel.telegramConfigCount > 0) filterString += 'telegramtg';
  if (connectedChannel.viberConfigCount > 0) filterString += 'viber';
  if (connectedChannel.weChatConfigCount > 0) filterString += 'wechat';
  if (connectedChannel.whatsAppConfigCount > 0)
    filterString += 'whatsapptwilio';
  if (connectedChannel.whatsappChatAPIConfigCount > 0)
    filterString += 'chatapi';
  if (connectedChannel.whatsapp360DialogConfigCount > 0)
    filterString += 'whatsapp360dialog';
  if (getLiveChatHostname(connectedChannel.webClientHost) != null)
    filterString += 'real';
  if (connectedChannel.webClientSenderCount > 0) filterString += 'livechat';
  if (connectedChannel.stripePaymentConfigCount > 0)
    filterString += 'stripepayment';
  if (
    connectedChannel.whatsappCloudApiConfigCount != null &&
    connectedChannel.whatsappCloudApiConfigCount > 0
  )
    filterString += 'whatsappcloudapi';
  if (connectedChannel.tikTokConfigCount > 0) filterString += 'tiktok';

  if (filterString === '') filterString = 'none';
  else filterString += 'any';

  return filterString;
}

export function shortenFileName(filename: string) {
  // filename format in api: {billRecordId-timeString-uploadFilename.extension}
  // ex: 117396743-20210823020407-logo.png
  // output: logo.png

  const firstHyphen = filename.indexOf('-');
  const secondHyphen = filename.indexOf('-', firstHyphen + 1);

  return filename.slice(secondHyphen + 1, filename.length);
}

export const getLiveChatHostname = (url: any) => {
  // use URL constructor and return hostname
  if (url == null || url === '') return null;

  if (url.toLowerCase().includes('preview.sleekflow.io')) return null;

  try {
    const u = new URL(url);
    return `${u.protocol}//${u.hostname}`;
  } catch (e) {
    return null;
  }
};
